import React, { FC } from 'react';
import { TypeCourseSupportingContentFields } from '@/core/generated-types';
import {
  Badge,
  CourseSong,
  CourseSongPreview,
  HeaderText,
  LuvImage,
  PdfDownload,
  RichText,
} from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';
import {
  RefetchTokenSetFn,
  RetrieveTokenSetFn,
} from '@/lib/api/playbackService/hooks/useTokenSetVault';
import { Document } from '@contentful/rich-text-types';

export interface TypeCourseAccessItemWithCourseData
  extends TypeCourseSupportingContentFields {
  retrieveSongAssetFromVault?: RetrieveTokenSetFn | undefined;
  fetchTokenSetForSongAsset?: RefetchTokenSetFn | undefined;
}

const CourseSupportingContent: FC<TypeCourseAccessItemWithCourseData> = ({
  details,
  courseSong,
  courseSongPreview,
  digitalPlayGuide,
  badge,
  retrieveSongAssetFromVault,
  fetchTokenSetForSongAsset,
}) => {
  const { image, textBody, textHeading } = details.fields;

  return (
    <div
      className="relative sm:mx-4 lg:max-w-[360px]"
      data-testid="course-supporting-content-item"
    >
      {badge && (
        <div className="absolute left-0 top-0 ml-4 mt-6">
          <Badge {...badge.fields} />
        </div>
      )}
      <LuvImage
        imageData={image}
        width={360}
        height={360}
        className="w-full lg:h-[360x] lg:w-[360px] lg:object-cover"
      />
      <HeaderText
        size={HeaderSize.H3}
        text={textHeading}
        align="left"
        classes="mt-4 mb-2"
      />
      <div className="text-left">
        {textBody && <RichText content={textBody as Document} />}
      </div>
      {courseSongPreview && <CourseSongPreview {...courseSongPreview.fields} />}
      {courseSong &&
        retrieveSongAssetFromVault &&
        fetchTokenSetForSongAsset && (
          <CourseSong
            {...courseSong.fields}
            retrieveSongAssetFromVault={retrieveSongAssetFromVault}
            fetchTokenSetForSongAsset={fetchTokenSetForSongAsset}
          />
        )}
      {digitalPlayGuide && (
        <PdfDownload
          pdf={digitalPlayGuide.fields}
          classes="flex align-start mt-2"
        />
      )}
    </div>
  );
};

export default React.memo(CourseSupportingContent);
